import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ShieldAlert, LogOut, Clock, Building } from 'lucide-react';

export default function SupportSessionBanner() {
  const { supportSessionTenant, endSupportSession } = useAuth();

  if (!supportSessionTenant) return null;

  return (
    <div className="bg-gradient-to-r from-amber-600 via-amber-500 to-amber-600 text-slate-900 px-4 py-2 text-xs font-bold flex items-center justify-between shadow-md border-b border-amber-400 sticky top-0 z-[999999]">
      <div className="flex items-center gap-3">
        <span className="flex items-center justify-center p-1 bg-amber-900/20 rounded-full animate-pulse text-amber-950">
          <ShieldAlert className="w-4 h-4" />
        </span>
        <div className="flex items-center gap-2">
          <span className="uppercase tracking-wider font-extrabold text-amber-950">
            Support Mode Active
          </span>
          <span className="text-amber-950/70 font-normal">|</span>
          <span className="flex items-center gap-1.5 font-medium text-slate-900 bg-amber-200/80 px-2 py-0.5 rounded border border-amber-400/60">
            <Building className="w-3.5 h-3.5 text-amber-800" />
            <span>Viewing Tenant: <strong>{supportSessionTenant.name || supportSessionTenant.client_name || `Tenant #${supportSessionTenant.id}`}</strong></span>
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className="hidden sm:flex items-center gap-1 text-amber-950/80 font-normal">
          <Clock className="w-3.5 h-3.5" />
          <span>Audited Session (Read-Only by default)</span>
        </span>
        <button
          onClick={endSupportSession}
          className="flex items-center gap-1.5 px-3 py-1 bg-slate-900 hover:bg-slate-800 text-white rounded-lg text-xs font-semibold shadow-sm transition-all cursor-pointer"
        >
          <LogOut className="w-3.5 h-3.5" />
          <span>Exit Support Mode</span>
        </button>
      </div>
    </div>
  );
}
